import { TriangleAlert } from "lucide-react";

import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

/**
 * Amber warning icon for a product row; hover/focus lists the concrete
 * warning(s). Renders nothing without warnings — future per-product checks
 * (missing platform, missing cost, …) append messages here instead of adding
 * more icons. The trigger is Radix's default button so it is keyboard
 * focusable, with the warnings as its accessible name.
 */
export function ProductWarningBadge({ warnings }: { warnings: string[] }) {
  if (warnings.length === 0) return null;
  // No TooltipProvider here — the app root mounts one at delayDuration={0}.
  // DESIGN.md points at this file as the standalone-Tooltip reference, so it
  // has to be the pattern it is pointing at.
  return (
    <Tooltip>
      <TooltipTrigger
        type="button"
        aria-label={warnings.join(". ")}
        className="inline-flex shrink-0 cursor-default"
      >
        <TriangleAlert aria-hidden="true" className="h-4 w-4 text-warning" />
      </TooltipTrigger>
      <TooltipContent className="max-w-xs">
        {warnings.map((w) => (
          <div key={w}>{w}</div>
        ))}
      </TooltipContent>
    </Tooltip>
  );
}
